var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 41,
    height: 41,
    rx: 19.1456,
    fill: "#6FBE45",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0067 22.5684C13.2727 22.5684 11.8682 23.9729 11.8682 25.7069C11.8682 27.441 13.2727 28.8455 15.0067 28.8455C16.7408 28.8455 18.1453 27.441 18.1453 25.7069C18.1453 23.9729 16.7408 22.5684 15.0067 22.5684ZM15.7914 25.4558C15.7914 25.9345 15.5324 26.3896 15.1244 26.6328L14.5281 26.9937C14.4339 27.0565 14.3241 27.08 14.2221 27.08C14.0259 27.08 13.8298 26.978 13.7199 26.7976C13.5551 26.523 13.6415 26.1542 13.9239 25.9894L14.5203 25.6285C14.5752 25.5971 14.6144 25.5265 14.6144 25.4637V24.734C14.6144 24.4044 14.8812 24.1376 15.2029 24.1376C15.5246 24.1376 15.7914 24.4044 15.7914 24.7261V25.4558Z",
    fill: "#0D4740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4229 14.7227H16.5765C14.2226 14.7227 12.6533 15.8996 12.6533 18.6459V21.4392C12.6533 21.7295 12.9515 21.91 13.2104 21.7923C13.9794 21.4392 14.866 21.3058 15.7997 21.4706C17.8633 21.8394 19.3777 23.7539 19.3228 25.8489C19.3149 26.1784 19.2678 26.5001 19.1815 26.814C19.1188 27.0572 19.3149 27.2848 19.566 27.2848H24.4229C26.7769 27.2848 28.3462 26.1078 28.3462 23.3616V18.6459C28.3462 15.8996 26.7769 14.7227 24.4229 14.7227ZM20.4997 22.9614C19.4169 22.9614 18.5381 22.0826 18.5381 20.9998C18.5381 19.917 19.4169 19.0382 20.4997 19.0382C21.5825 19.0382 22.4613 19.917 22.4613 20.9998C22.4613 22.0826 21.5825 22.9614 20.4997 22.9614ZM26.1884 22.5691C26.1884 22.8908 25.9216 23.1576 25.5999 23.1576C25.2782 23.1576 25.0114 22.8908 25.0114 22.5691V19.4305C25.0114 19.1088 25.2782 18.842 25.5999 18.842C25.9216 18.842 26.1884 19.1088 26.1884 19.4305V22.5691Z",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsFilled);
export default __webpack_public_path__ + "static/media/savings-filled.acc29a2a4ed1a1fef1e1b653fc394d53.svg";
export { ForwardRef as ReactComponent };